import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './utils/axios'  // 导入已配置的axios实例
import message from './plugins/message'

// 导入 Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import axios from 'axios'

// 配置 axios
axios.defaults.baseURL = 'https://abc.atmcorr.com'
axios.defaults.timeout = 5000

// 添加请求拦截器
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('adminToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 添加响应拦截器
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken')
      localStorage.removeItem('admin')
      router.push('/admin/login')
    }
    return Promise.reject(error)
  }
)

// 忽略 ResizeObserver 警告
const debounce = (fn, delay) => {
  let timeoutId
  return (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
    timeoutId = setTimeout(() => {
      fn.apply(null, args)
    }, delay)
  }
}

const errorHandler = debounce((error) => {
  if (error.message === 'ResizeObserver loop completed with undelivered notifications.') {
    return
  }
  console.error(error)
}, 100)

window.addEventListener('error', errorHandler)

// 创建 Vue 应用实例
const app = createApp(App)

// 注册所有 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 全局挂载axios实例
app.config.globalProperties.$axios = api;

app.use(router)
app.use(store)
app.use(message)
app.use(ElementPlus, {
  locale: zhCn,
})
// 初始化认证状态
store.dispatch('user/checkAuth')

// 注册全局权限指令
app.directive('permission', {
  mounted(el, binding) {
    const hasPermission = store.getters['admin/hasPermission'](binding.value)
    if (!hasPermission) {
      el.parentNode?.removeChild(el)
    }
  }
})

// 确保 DOM 加载完成后再挂载应用
document.addEventListener('DOMContentLoaded', () => {
  app.mount('#app')
})

if (typeof window !== 'undefined') {
  const urlParams = new URLSearchParams(window.location.search)
  const token = urlParams.get('token')
  if (token) {
    localStorage.setItem('token', token)
    // 去掉 token 参数，防止泄露
    const url = new URL(window.location)
    url.searchParams.delete('token')
    window.history.replaceState({}, '', url)
  }
}
